/**
 * @generated SignedSource<<c822224d8f78f3ad3395c9fb9f932c3b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RehomeStakeholderInputObject = {
  fromCategoryId?: string | null | undefined;
  perspectiveId: string;
  sliceType?: string | null | undefined;
  stakeholderId: string;
  toCategoryId: string;
};
export type pnlMonthPage_RehomeMutation$variables = {
  input: RehomeStakeholderInputObject;
};
export type pnlMonthPage_RehomeMutation$data = {
  readonly rehomeStakeholder: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly stakeholder: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type pnlMonthPage_RehomeMutation = {
  response: pnlMonthPage_RehomeMutation$data;
  variables: pnlMonthPage_RehomeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "stakeholder",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "pnlMonthPage_RehomeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RehomeStakeholderMutationPayload",
        "kind": "LinkedField",
        "name": "rehomeStakeholder",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "pnlMonthPage_RehomeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RehomeStakeholderMutationPayload",
        "kind": "LinkedField",
        "name": "rehomeStakeholder",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d82f590633d93d574a7e85e9b9c6d663",
    "id": null,
    "metadata": {},
    "name": "pnlMonthPage_RehomeMutation",
    "operationKind": "mutation",
    "text": "mutation pnlMonthPage_RehomeMutation(\n  $input: RehomeStakeholderInputObject!\n) {\n  rehomeStakeholder(input: $input) {\n    stakeholder {\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4127f17f3aa84e5bcadb27a93d856b45";

export default node;
